import { useDispatch } from "react-redux";
import { useEffect } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  Route,
  createRoutesFromElements,
} from "react-router-dom";

import RootLayout from "./root";
import Account from "./legacy/account";
import UserDocument from "./legacy/account/userdocument";
import { checkAutoLogin } from "./v2/redux/auth";
import TradeOfCredit from "./legacy/finance/trade";
import Factoring from "./legacy/finance/factoring";
import Letterofcredit from "./legacy/finance/letter_of_credit";
import Order from "./legacy/flex/order";
import Invoice from "./legacy/flex/invoice";
import Buyers from "./legacy/flex/buyer";
import Suppliers from "./legacy/flex/supplier";
import Card from "./legacy/flex/card";
import Settings from "./legacy/settings/home";
import UserAccount from "./legacy/account/userAccount";
import FinanceHome from "./legacy/finance/home";
import FinanceDetails from "./legacy/finance/financedetails";
import FinanaceProof from "./legacy/finance/financeproof";
import ApproveRequest from "./legacy/finance/approveRequest";
import VerifyDocumentTab from "./legacy/account/verifyDocument";
import FundRequest from "./legacy/fundrequest/accept";
import ChangeTerm from "./legacy/changeterm/term";
import AccountEdit from "./legacy/settings/account";
import FlexHome from "./legacy/flex/home";
import FlexDetails from "./legacy/flex/flexdetails";
import OrderDetails from "./legacy/flex/orderdetails";
import SingleFlexInvoice from "./legacy/flex/flexinvoice";
import PurchaseOrderDocument from "./legacy/flex/purchase_order";
// Old transaction pages (commented out per requirement):
// import Transactions from "./legacy/transaction/home";
// import EachTransactionDetail from "./legacy/transaction/eachwalletdetails";
import TransactionsPageV2 from "./v2/features/transactions/pages/TransactionsPage";
import TransactionDetailsPage from "./v2/features/transactions/pages/TransactionDetailsPage";
import Wallets from "./legacy/wallet/home";
import WalletDetails from "./legacy/wallet/walletdetails";
import AdminDetails from "./legacy/settings/admindetails";
import AdminInvite from "./legacy/admininvite/invite";
import TransferRequest from "./legacy/transfer/home";
import TransferDetails from "./legacy/transfer/transferdetail";
import FundWallet from "./legacy/wallet/fund";
import Receipt from "./legacy/receipt/home";
import ReviewDocuments from "./legacy/finance/review";
import LenderAgreementContainer from "./legacy/lenderagreement/lenderagreement";
import PaymentHome from "./legacy/payments/home";
import PaymentDetails from "./legacy/payments/paymentdetails";
import PaymentViewDocument from "./legacy/payments/view_document";
import TransferPay from "./legacy/transfer/pay";
import InvoiceFlexPayDetails from "./legacy/transfer/invoice";
import ProofOfAddress from "./legacy/account/proofofaddress";
import DashboardHome from "./legacy/dashboard/home";
import RecordPayment from "./legacy/payments/record";
import ApproveFunds from "./legacy/finance/approveFunds";
import TeamManagementPage from "./v2/features/team-management/pages/TeamManagementPage";
import ActivityHomePage from "./v2/features/activity/pages/ActivityHomePage";
import NotificationHomePage from "./v2/features/notification/pages/NotificationHomePage";
import KybCompliancePage from "./v2/features/kyb-compliance/pages/KybCompliancePage";
import KybComplianceDetailsPage from "./v2/features/kyb-compliance/pages/KybComplianceDetailsPage";
import KybComplianceUpdateInformationPage from "./v2/features/kyb-compliance/pages/KybComplianceUpdateInformationPage";
import AuthLayout from "./v2/app/layouts/AuthLayout";
import LoginPage from "./v2/features/auth/pages/login";
import VerificationCodePage from "./v2/features/auth/pages/verification-code";
import BackupCodePage from "./v2/features/auth/pages/backup-code";
import SignInPage from "./v2/features/auth/pages/sign-in";
import Setup2FAPage from "./v2/features/auth/pages/setup-2fa";
import { PAGES } from "./v2/shared/lib/pageUrlConstants";
import AccountSettings from "./v2/features/account-settings/pages";
import ApproveFinance from "./legacy/finance/approveFinance";
import {
  CompleteTransferPage,
  OtcRequestsPage,
  OtcRequestDetailsPage,
} from "./v2/features/otc-requests/pages";

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route element={<AuthLayout />}>
        <Route index element={<LoginPage />} />
        <Route path={PAGES.verifyMfa} element={<VerificationCodePage />} />
        <Route path={PAGES.recoverCode} element={<BackupCodePage />} />
        <Route path={PAGES.signIn} element={<SignInPage />} />
        <Route path={PAGES.setup2fa} element={<Setup2FAPage />} />
        <Route path="/admin/complete-profile/:token/:email" element={<AdminInvite />} />
      </Route>
      <Route
        path={`${PAGES.kybComplianceUpdateInformation}/:businessId`}
        element={<KybComplianceUpdateInformationPage />}
      />
      <Route
        path="/transaction/:id/complete-transfer"
        element={<CompleteTransferPage />}
      />
      <Route
        path="/v2/transactions/:id/complete-transfer"
        element={<CompleteTransferPage />}
      />
      <Route
        path="/transactions-v2/:id/complete-transfer"
        element={<CompleteTransferPage />}
      />
      <Route
        path={`${PAGES.transactionsV2}/:id/complete-transfer`}
        element={<CompleteTransferPage />}
      />
      <Route
        path="/otc-requests/:id/complete-transfer"
        element={<CompleteTransferPage />}
      />
      <Route element={<RootLayout />} path="/">
        <Route path="/dashboard" element={<DashboardHome />} />
        <Route path="/team-management" element={<TeamManagementPage />} />
        <Route path="/activity" element={<ActivityHomePage />} />
        <Route path="/broadcast" element={<NotificationHomePage />} />
        <Route path={PAGES.kybCompliance} element={<KybCompliancePage />} />
        <Route
          path={`${PAGES.kybCompliance}/:id`}
          element={<KybComplianceDetailsPage />}
        />
        <Route path="/finance/:id" element={<FinanceDetails />} />
        <Route element={<ProofOfAddress />} path="/proof_of_address" />
        <Route element={<VerifyDocumentTab />} path="/verifyDocument" />
        <Route element={<PaymentHome />} path="/payment/home" />
        <Route element={<PaymentDetails />} path="/payment/:id" />
        <Route element={<PaymentViewDocument />} path="/payment/document" />
        <Route element={<TransferPay />} path="/transfer/pay" />
        <Route element={<InvoiceFlexPayDetails />} path="/pay/invoice/:id" />

        <Route path="/account" element={<Account />} />
        <Route path={PAGES.legacyAccounts} element={<Account />} />
        <Route path={PAGES.accountSettings} element={<AccountSettings />} />
        <Route path="/finance" element={<FinanceHome />} />
        <Route path="/flex" element={<FlexHome />} />
        <Route path="/flex/:id" element={<FlexDetails />} />
        <Route path="/flex/order/:id" element={<OrderDetails />} />
        {/* Old transaction routes (commented out per requirement):
        <Route path="transaction/home" element={<Transactions />} />
        <Route path="transaction/home/:id" element={<EachTransactionDetail />} /> */}
        {/* Backward-compatible alias routing to new transaction pages */}
        <Route path="transaction/home" element={<TransactionsPageV2 />} />
        <Route path="transaction/home/:id" element={<TransactionDetailsPage />} />
        <Route path={PAGES.transactionsV2} element={<TransactionsPageV2 />} />
        <Route path={`${PAGES.transactionsV2}/:id`} element={<TransactionDetailsPage />} />
        <Route path="/transaction" element={<TransactionsPageV2 />} />
        <Route path="/transaction/:id" element={<TransactionDetailsPage />} />
        <Route path="/transactions-v2" element={<TransactionsPageV2 />} />
        <Route path="/transactions-v2/:id" element={<TransactionDetailsPage />} />
        <Route path="/v2/transactions" element={<TransactionsPageV2 />} />
        <Route path="/v2/transactions/:id" element={<TransactionDetailsPage />} />
        <Route path="/v2/transactions/:id/complete-transfer" element={<CompleteTransferPage />} />
        <Route path="/transactions-v2/:id/complete-transfer" element={<CompleteTransferPage />} />
        <Route path="/transaction/:id/complete-transfer" element={<CompleteTransferPage />} />
        <Route path={`${PAGES.transactionsV2}/:id/complete-transfer`} element={<CompleteTransferPage />} />
        <Route path={PAGES.otcRequests} element={<OtcRequestsPage />} />
        <Route path={`${PAGES.otcRequests}/:id`} element={<OtcRequestDetailsPage />} />
        <Route path="/otc-requests/:id/complete-transfer" element={<CompleteTransferPage />} />
        <Route path="wallet/home" element={<Wallets />} />
        <Route path="wallet" element={<WalletDetails />} />
        <Route path="transfer/request" element={<TransferRequest />} />
        <Route path="transfer/request/:id" element={<TransferDetails />} />
        <Route path="wallet/fund/" element={<FundWallet />} />
        <Route path="payment/record" element={<RecordPayment />} />

        <Route path="admin/:id" element={<AdminDetails />} />
        <Route path="/purchase_order/document" element={<PurchaseOrderDocument />} />
        <Route path="/flex/invoice/:id" element={<SingleFlexInvoice />} />
        <Route path="/account/:id" element={<UserAccount />} />

        <Route path="/account/document/:id" element={<UserDocument />} />
        <Route path="/finance/fundrequest" element={<FundRequest />} />
        <Route path="/finance/changeterm" element={<ChangeTerm />} />
        <Route path="/account/edit" element={<AccountEdit />} />

        <Route path="/finance/trade" element={<TradeOfCredit />} />
        <Route path="/finance/document" element={<FinanaceProof />} />

        <Route path="/finance/review" element={<ReviewDocuments />} />

        <Route path="/finance/factoring" element={<Factoring />} />
        <Route path="/finance/letter_of_credit" element={<Letterofcredit />} />
        <Route path="/finance/disburse_approved_funds/:id" element={<ApproveFunds />} />
        <Route path="/finance/approve_request/:id" element={<ApproveRequest />} />
        <Route path="/finance/approve_request_new/:id" element={<ApproveFinance />} />

        <Route path="/flex/order" element={<Order />} />
        <Route path="/flex/invoice" element={<Invoice />} />
        <Route path="/flex/buyers" element={<Buyers />} />
        <Route path="/flex/supplier" element={<Suppliers />} />
        <Route path="/flex/card" element={<Card />} />
        <Route path="/settings/home" element={<Settings />} />
        <Route path="/receipt/home" element={<Receipt />} />
        <Route path="/lender/agreement" element={<LenderAgreementContainer />} />
      </Route>
    </>,
  ),
);
function App() {
  const dispatch = useDispatch();
  useEffect(() => {
    checkAutoLogin(dispatch);
  }, [dispatch]);

  return <RouterProvider router={router} />;
}

export default App;
